import styles from './customPatchesPopup.module.css'

// we need to show a popup with the following message: "Once approved, any changes will require a new upload and design id"
// the popup will show a warning sign to the left of the message
// and below two buttons will show
// one button will show the text "Approve"
// the other button will show the text "Go Back"
// approve calls updateApprovedState(itemId)
// go back closes the popup without calling updateApprovedState
export const CustomPatchesPopup = ({ isOpen, onClose, onConfirm }: { isOpen: boolean, onClose: () => void, onConfirm: () => void }) => {
  if (!isOpen) return null;

  return (
    <div className={styles.popupOverlay}>
      <div className={styles.popupContent}>
        <div className={styles.popupHeader}>
          <span className={styles.warningSign}>⚠️</span>
          <p>Once approved, any changes will require a new upload and design id</p>
        </div>
        <div className={styles.popupActions}>
          <button className={styles.popupButton} onClick={onConfirm}>Approve</button>
          <button className={styles.popupButton} onClick={onClose}>Go Back</button>
        </div>
      </div>
    </div>
  );
};